import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Box, Copy } from '@elparking/components'

const AmountWrapper = ({ children }) =>
    <Copy as='h3' padding='0' fontColor='accent_dark' fontSize={['28px', 'xxxLarge']} fontWeight='bold'>
        {children}
    </Copy>

AmountWrapper.propTypes = {
    children: PropTypes.node,
}

const PriceBlock = ({ rate, flexDirection, textAlign, isMutuaUser }) => {
    return <Box textAlign={textAlign}>
        <Box mb='10px' mt={flexDirection === 'row' ? '0' : '10px'}>
            <Box width='100%'>
                <AmountWrapper>{rate.displayPrice}</AmountWrapper>
            </Box>
            { isMutuaUser && <Copy padding='0' fontColor='accent_dark' fontSize='small' fontWeight='regular'>
                <FormattedMessage defaultMessage='Precio exclusivo' />
            </Copy>}
        </Box>
    </Box>
}

PriceBlock.propTypes = {
    flexDirection: PropTypes.string,
    textAlign: PropTypes.string,
    rate: PropTypes.shape({
        displayPrice: PropTypes.string,
        price: PropTypes.any,
        exclusive: PropTypes.bool,
    }),
    isMutuaUser: PropTypes.bool,
}

export default PriceBlock
